import {
  Component,
  EventEmitter,
  inject,
  input,
  type OnInit,
  Output,
  signal,
} from '@angular/core';
import { FinoButtonModule } from '@fino-ui/button';
import type { SubmittableForm } from '@fino-ui/forms';
import { FinoInputModule } from '@fino-ui/input';
import { FinoSelectModule } from '@fino-ui/select';
import { FinoTranslationModule } from '@fino-ui/translation';
import { finalize } from 'rxjs';
import { COMMENT_PRESETS } from '../capture-transaction.constants';
import { reportForm } from '../capture-transaction.form.constants';
import { CaptureTransactionService } from '../capture-transaction.service';

@Component({
  selector: 'app-report-document',
  imports: [
    FinoButtonModule,
    FinoTranslationModule,
    FinoSelectModule,
    FinoInputModule,
  ],
  templateUrl: './report-document.component.html',
})
export class ReportDocumentComponent implements OnInit {
  public reportForm: SubmittableForm = reportForm;

  public reportDocumentLoading = signal(false);

  private readonly captureTransactionService = inject(
    CaptureTransactionService,
  );

  public reportPresetItems = COMMENT_PRESETS;

  readonly jobId = input(undefined);
  readonly transactions = input(undefined);
  @Output() documentReported = new EventEmitter();

  reportDocument() {
    this.reportDocumentLoading.set(true);
    this.captureTransactionService
      .reportDocument(
        this.jobId(),
        this.reportForm.controls.comment.value,
        this.transactions(),
      )
      .pipe(finalize(() => this.reportDocumentLoading.set(false)))
      .subscribe(() => {
        this.reportForm.reset();
        this.documentReported.emit();
      });
  }

  ngOnInit(): void {
    this.reportForm.controls.preset?.valueChanges.subscribe((change) => {
      this.reportForm.patchValue({
        comment: change,
      });
    });
  }
}
